import React from "react";
import { GitCompareArrows, X, ChevronUp } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useComparison } from "@/hooks/use-comparison";
import { AnimatePresence, motion } from "framer-motion";

export function ComparisonBar() {
  const { comparedHomes, removeFromComparison, clearComparison, setIsOpen } = useComparison();

  if (comparedHomes.length === 0) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ y: 100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: 100, opacity: 0 }}
        transition={{ type: "spring", stiffness: 300, damping: 30 }}
        className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-border shadow-2xl"
      >
        <div className="container py-3 flex items-center gap-3 flex-wrap">
          {/* Label */}
          <div className="flex items-center gap-2 text-sm font-medium text-foreground shrink-0">
            <GitCompareArrows size={16} className="text-grandpal-green" />
            Comparing ({comparedHomes.length}/4)
          </div>

          {/* Home chips */}
          <div className="flex items-center gap-2 flex-1 flex-wrap">
            {comparedHomes.map((home) => (
              <div
                key={home.nh_slug}
                className="flex items-center gap-1.5 bg-grandpal-beige border border-grandpal-green/30 rounded-full px-3 py-1 text-sm"
              >
                <span className="font-medium truncate max-w-[160px]">{home.center_name}</span>
                <button
                  onClick={() => removeFromComparison(home.nh_slug)}
                  className="text-muted-foreground hover:text-foreground transition-colors shrink-0"
                >
                  <X size={12} />
                </button>
              </div>
            ))}

            {/* Empty slots */}
            {Array.from({ length: 4 - comparedHomes.length }).map((_, i) => (
              <div
                key={i}
                className="flex items-center border border-dashed border-border rounded-full px-3 py-1 text-sm text-muted-foreground"
              >
                + Add home
              </div>
            ))}
          </div>

          {/* Actions */}
          <div className="flex items-center gap-2 shrink-0">
            <Button
              variant="ghost"
              size="sm"
              onClick={clearComparison}
              className="text-muted-foreground hover:text-foreground text-xs"
            >
              Clear all
            </Button>
            <Button
              size="sm"
              onClick={() => setIsOpen(true)}
              disabled={comparedHomes.length < 2}
              className="bg-grandpal-green-dark hover:bg-grandpal-green-dark/90 gap-1.5"
            >
              <ChevronUp size={14} />
              Compare now
            </Button>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
}
